import { generateSectionParagraphs } from "../utils/WordExportUtils";
import {
  blueColour,
  defaultFontBold,
  defaultFontItalic,
  defaultFontNormal,
} from "../utils/styling";

export const getDerivativesParagraphs = (data) => {
  const { poaData, groupName } = data;

  const isSumNtdcTdcSubtotalsZero = poaData.adjusted_caps
    .map((cap) => cap.ntdc_subtotal.value + cap.tdc_subtotal.value)
    .every((item) => item === 0);

  const paragraphs = [
    {
      condition: true,
      segments: [
        {
          text: "Derivatives:",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "The Corporate Interest Restriction rules recognise that certain derivative contracts can give rise to interest-like amounts that it was considered inappropriate to exclude them from the definition of Tax-Interest. As such, certain debits and credits arising on derivative contracts with an underlying subject matter of interest rates, currency, loan relationships or any index determined by reference to income or retail prices are included within the definition of Tax-Interest.",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "However, any debits or credits that relate to excluded matters are also excluded from Tax-Interest regardless of the underlying subject matter of the derivative. These include those debits and credits in respect of:",
          font: defaultFontNormal,
          break: 2,
        },
      ],
    },
    {
      condition: true,
      bullet: "dot",
      bullet_level: 0,
      segments: [
        {
          text: "A risk arising in the ordinary course of a trade (other than a financial trade) where the derivative was entered into for reasons wholly unrelated to the capital structure of the worldwide group (or any member of it);",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: true,
      bullet: "dot",
      bullet_level: 0,
      segments: [
        {
          text: "Exchange gains and losses; and",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: true,
      bullet: "dot",
      bullet_level: 0,
      segments: [
        {
          text: "Impairment losses or their reversal.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "Application to the ",
          font: defaultFontItalic,
          break: 1,
        },
        {
          text: groupName,
          font: defaultFontItalic,
        },
        {
          text: " group",
          font: defaultFontItalic,
        },
      ],
    },
    {
      condition: isSumNtdcTdcSubtotalsZero,
      segments: [
        {
          text: "We are not aware of any derivative contracts entered into by UK group companies. If you are aware of any such contracts please let us know so that the position can be considered further.",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "[Relationship team to confirm there are no derivatives in the loan relationship section.]",
          font: defaultFontNormal,
          color: blueColour,
          break: 2,
        },
      ],
    },
    {
      condition: !isSumNtdcTdcSubtotalsZero,
      segments: [
        {
          text: "[Relationship team to add commentary as to the treatment of derivatives, including whether any amounts have been included as Tax-Interest. This should also include some commentary on the application of s420 TIOPA 2010, which requires that, in calculating Group-Interest (e.g. for ANGIE) and Group-EBITDA (if a group ratio election is made), it is assumed that a Disregard Regulation election is made by the group.]",
          font: defaultFontNormal,
          color: blueColour,
          break: 1,
        },
      ],
    },
  ];

  return [...generateSectionParagraphs(paragraphs)];
};
